/**
 * Upload subtitles TXT to S3 using presigned URL.
 * @param {Blob} blob - Subtitles TXT content
 * @param {string} filename - Subtitles filename
 * @param {Object} endpoint - Endpoint with url and method to get presigned URL
 * @returns {Promise<{ success: boolean, url?: string, error?: string }>}
 */
export async function uploadSubtitlesToS3(blob, filename, endpoint) {
    try {
        const presignedResponse = await fetch(endpoint.url, {
            method: endpoint.method,
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
                filename,
            }),
        });

        if (!presignedResponse.ok) {
            const errText = await presignedResponse.text();
            return {
                success: false,
                error: `Error getting upload URL: ${presignedResponse.status} - ${errText}`,
            };
        }

        const data = await presignedResponse.json();

        const uploadUrl = data.uploadUrl || data.url;

        if (!uploadUrl) {
            return { success: false, error: 'Response does not contain uploadUrl' };
        }

        const uploadResponse = await fetch(uploadUrl, {
            method: 'PUT',
            body: blob,
            headers: { 'Content-Type': 'text/plain' },
            redirect: 'follow',
        });

        if (!uploadResponse.ok) {
            return { success: false, error: `Error uploading to S3: ${uploadResponse.status}` };
        }

        return { success: true, url: uploadUrl.split('?')[0] };
    } catch (err) {
        return { success: false, error: err.message || 'Unknown error uploading' };
    }
}
